import React from 'react'
import { number, object, string } from 'prop-types'
import { css } from '@emotion/react'

import useHydrationContext from '@/hooks/useHydrationContext'
import mediaQueries from '@/layout/media-queries'
import { roundUpWithDecimal } from '@/utils/func'
import StarsRates from './StarsRate'
import VotesDistribution from './VotesDistribution'

const summaryWrapperCss = css`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  ${mediaQueries.smallScreen(-100)} {
    flex-direction: row;
  }
`

const ratesInfoWrapperCss = css`
  display: flex;
  flex-direction: column;

  ${mediaQueries.xsmallScreen(-30)} {
    flex-direction: row;
    justify-content: space-between;
  }

  ${mediaQueries.smallScreen(-100)} {
    justify-content: flex-start;
  }
`

const ratesSummaryTextCss = css`
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
  margin: 0;
  height: 56px;
  font-size: 12px;
  font-weight: bold;

  > span:first-of-type {
    font-size: 56px;
    line-height: 44px;
  }
`

const ReviewsSummary = ({ id, votes = 0, rate = 0, histogram, developer }) => {
  const hydrated = useHydrationContext()
  const decimalRate = roundUpWithDecimal(rate)

  return (
    hydrated && (
      <div css={summaryWrapperCss} data-test="reviewsSummary">
        <div css={ratesInfoWrapperCss}>
          <p css={ratesSummaryTextCss}>
            <span>{decimalRate}</span>
            <span>
              out of 5 • {votes} {votes === 1 ? 'Rating' : 'Ratings'}
            </span>
          </p>

          <VotesDistribution histogram={histogram} />
        </div>

        <StarsRates id={id} developer={developer} />
      </div>
    )
  )
}

ReviewsSummary.propTypes = {
  id: string,
  votes: number,
  rate: number,
  histogram: object,
  developer: object,
}

export default ReviewsSummary
